/** First-release app API. Keep this separate from the existing API transports. */
export const APP_API_ORIGIN = 'https://app-api.callsyncapp.com';

export function appRecordingKey(raw: string): string | null {
  try {
    const url = new URL(raw);
    if (url.origin !== APP_API_ORIGIN || url.pathname !== '/v1/recordings/file' || url.username || url.password) return null;
    const key = url.searchParams.get('key');
    return key && /^[A-Za-z0-9_-]+\/\d+\/.+/.test(key) && !key.includes('..') && !key.includes('\\') ? key : null;
  } catch { return null; }
}
